// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"25c0ca68","455":"2b046b70","977":"0e4ec9c7"}[chunkId] + ".chunk.js";
};